import { LucideIcon, TrendingDown, TrendingUp } from 'lucide-react';

import { OverheadType } from '../types/overhead';

/**
 * Icon per overhead type — shared by the summary cards, the collapsed chip
 * strip, and the table's name column so the visual language stays consistent.
 */
export const getOverheadTypeIcon = (type: OverheadType): LucideIcon =>
  type === OverheadType.Income ? TrendingUp : TrendingDown;
